import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pronto-intervento-1/artifacts/ofmhj622_ss%20logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#29383d] pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <img
              src={LOGO_URL}
              alt="Scavone Service E&J"
              className="h-10 w-auto mb-6"
              data-testid="footer-logo"
            />
            <p className="text-white/70 leading-relaxed mb-6 max-w-md">
              Scavone Service E&J - Da oltre 15 anni al servizio del Veneto 
              per soluzioni energetiche e impiantistiche di qualità.
            </p>
            <div className="space-y-3">
              <a
                href="tel:+393292656988"
                className="flex items-center gap-3 text-white/70 hover:text-[#5abb3d] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5" />
                +39 329 265 6988
              </a>
              <a
                href="mailto:info@scavoneservicesrl.com"
                className="flex items-center gap-3 text-white/70 hover:text-[#5abb3d] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5" />
                info@scavoneservicesrl.com
              </a>
              <div className="flex items-center gap-3 text-white/70">
                <MapPin className="w-5 h-5" />
                Via XXV Aprile, 1 - Quarto d'Altino, VE 30020
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-outfit text-lg font-semibold text-white mb-6">
              Link Rapidi
            </h4>
            <ul className="space-y-3">
              {[
                { href: "#servizi", label: "Servizi" },
                { href: "#chi-siamo", label: "Chi Siamo" },
                { href: "#galleria", label: "Galleria" },
                { href: "#testimonianze", label: "Testimonianze" },
                { href: "#preventivo", label: "Preventivo" },
                { href: "#contatti", label: "Contatti" },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-white/70 hover:text-[#5abb3d] transition-colors"
                    data-testid={`footer-link-${link.href.replace('#', '')}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit text-lg font-semibold text-white mb-6">
              Servizi
            </h4>
            <ul className="space-y-3">
              {[
                "Climatizzazione",
                "Caldaie",
                "Fotovoltaico",
                "Ristrutturazione Tetti",
                "Pronto Intervento Elettrico",
                "Pronto Intervento Idraulico",
              ].map((service) => (
                <li key={service}>
                  <span className="text-white/70">{service}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm text-center md:text-left">
            © {currentYear} Scavone Service E&J. Tutti i diritti riservati.
          </p>
          <p className="text-white/50 text-sm">
            P.IVA: XXXXXXXXXX | Operativi in tutto il Veneto
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
